import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { z } from 'zod';

import { HelpCentrePlatformGuidesPage } from '@/features/help-centre/HelpCentrePlatformGuidesPage';
import type { HelpModuleKey } from '@/features/help-centre/content';
import i18n from '@/lib/i18n';

const searchSchema = z.object({
  q: z.string().optional().default(''),
  module: z
    .enum([
      'all',
      'analytics',
      'assets',
      'controls',
      'dashboard',
      'evidence',
      'ghg',
      'incidents',
      'risks',
      'tasks',
      'vulnerabilities',
    ])
    .optional()
    .default('all'),
  type: z.enum(['all', 'functional', 'technical']).optional().default('all'),
});

export const Route = createFileRoute('/_authenticated/help-centre/platform-guides')({
  validateSearch: searchSchema,
  beforeLoad: () => ({
    getTitle: () => i18n.t('routeTitles.helpCentrePlatformGuides'),
  }),
  component: HelpCentrePlatformGuidesRoute,
});

function HelpCentrePlatformGuidesRoute() {
  const navigate = useNavigate({ from: Route.fullPath });
  const search = Route.useSearch();

  const updateSearch = (
    updates: Partial<{
      q: string;
      module: HelpModuleKey | 'all';
      type: 'all' | 'functional' | 'technical';
    }>
  ) => {
    void navigate({
      search: (prev) => ({
        ...prev,
        ...updates,
      }),
      replace: true,
    });
  };

  return (
    <HelpCentrePlatformGuidesPage
      query={search.q}
      moduleKey={search.module}
      guideType={search.type}
      onQueryChange={(q) => updateSearch({ q })}
      onModuleChange={(module) => updateSearch({ module })}
      onGuideTypeChange={(type) => updateSearch({ type })}
    />
  );
}
